import { render, staticRenderFns } from "./jobGroupCardBlockKanban.vue?vue&type=template&id=70fb6dc2"
import script from "./jobGroupCardBlockKanban.vue?vue&type=script&lang=js"
export * from "./jobGroupCardBlockKanban.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports